<ng-container *ngIf="isShowHardwareDetail">
    <p-dialog
        [header]="selectHardware?.name"
        [dismissableMask]="true"
        [(visible)]="isShowHardwareDetail"
        [modal]="true"
        [draggable]="false"
        [resizable]="true"
        [style]="{ width: '30vw' }"
        [breakpoints]="{ '1300px': '80vw', '640px': '100vw' }"
    >
        <div class="flex flex-column">
            <div class="hd-cat-image">
                <img [src]="selectHardware?.image" />
            </div>
            <div class="hd-cat-title">
                <label>
                    {{ selectHardware?.title }}
                </label>
            </div>
            <div class="hd-cat-description">
                <p [innerHTML]="selectHardware?.rawData"></p>
            </div>
        </div>
    </p-dialog>
</ng-container>

<div class="flex justify-content-center">
    <span class="flex justify-content-center w-full cursor-pointer">
        <a href="https://lincsell.com/" target="_blank"><img  src="assets/images/LincSell-Main.svg" width="150px" alt="Lincsell"></a>
    </span>
    <span class="flex justify-content-end px-4">
        <i (click)="cancel()"  class="pi pi-times text-4xl p-1 mx-4 cursor-pointer"></i>
    </span>
</div>
<div class="flex justify-content-center mx-4 p-4 py-4">
    <div class="col-12">
        <!-- <div class="w-full p-4"> -->
        <div class="flex justify-content-center">
            <div
                class="text-lg text-500 font-medium flex flex-column justify-content-center mb-4 w-11 md:w-8 lg:w-4 lx:w-4"
            >
            <div class="flex justify-content-between">
                <div class="flex">
                    <div class="pb-4">
                        Step 2 of 3
                    </div>
                </div>
                <!-- <div class="flex">
                    <div class="pb-4">
                        <a href="javascript:void(0)" title="Logout" (click)="logout()">
                            <i class="mb-4 pi pi-power-off text-2xl text-success"></i>
                        </a>
                    </div>
                </div> -->
            </div>
                <span class="flex justify-content-between">
                    <a
                        *ngIf="_signup.accountVerified"
                        (click)="previousPage()"
                        title="back to personal information"
                        class="details-link cursor-pointer back-link"
                        ><i
                            class="pi pi-arrow-circle-left text-3xl text-primary"
                        ></i>
                    </a>
                    <span class="flex align-items-center " [ngClass]="{'cursor-pointer' :_signup.accountVerified}" (click)="previousPage()"
                        >
                        <img src="assets/icons/checked.svg" class="pr-2" />
                        <span>Personal Information</span></span
                    >
                    <i class="pi pi-angle-right flex align-items-center"></i>
                    <strong class="text-900 flex align-items-center"
                        >Plan and Billing</strong
                    >
                    <i class="pi pi-angle-right flex align-items-center"></i>
                    <span class="flex align-items-center">Checkout</span>
                </span>
            </div>
        </div>

        <!-- /Plans -->

        <div class="col-12 flex justify-content-center">
            <div class="grid xl:col-11 col-12 justify-content-center">
                <div class="xl:col-8 lg:col-6 md:col-12 sm:col-12">
                    <div class="flex flex-wrap justify-content-start ">
                        <div
                            class="xl:col-4 lg:col-4 md:col-4 sm:col-12 col-12 pt-0 text-align-center"
                            *ngFor="let plan of plans"
                        >
                            <div [ngClass]="{'planselected': plan.selected}"></div>
                            <p-card
                                class="widget"
                                *ngIf="plan.planName !== 'Enterprise'"
                                [ngClass]="{'selected-subscription': plan.selected}"

                            >
                                <div class="grid"   style="min-height: 13em;">
                                    <div class="col-12">
                                        <h4 class="package-title">
                                            {{ plan?.planName }}
                                            <a
                                                (click)="goToPricing()"
                                                class="details-link cursor-pointer"
                                                ><i
                                                    class="pi pi-external-link"
                                                ></i>
                                            </a>
                                        </h4>

                                        <div class="price">
                                            <span class="amount">
                                                <span class="font-bold">{{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? (plan?.yearlyPrice
                                                            | currency | currencySpacing)
                                                        : (plan?.monthlyPrice
                                                            | currency | currencySpacing)
                                                }}</span>
                                                </span>
                                                <span class="duration">/mo.</span>

                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="flex justify-content-center align-content-center vertical-align-middle">
                                            <small class="text-info"> {{ plan?.detail }}</small>
                                        </div>

                                    </div>
                                    <div class="col-12">
                                        <div class="flex justify-content-center align-content-center vertical-align-middle">
                                            <button
                                                class="selected-btn w-full pricing-card-selected-btn"
                                                *ngIf="
                                                    plan?.selected === true &&
                                                    plan?.CTA !== 'contact'
                                                "
                                                (click)="selectPlan(plan)"
                                            >
                                                <i class="pi pi-minus"></i> Unsubscribe
                                            </button>

                                            <button
                                                class="select-btn w-full pricing-card-select-btn"
                                                *ngIf="plan?.CTA === 'contact'"
                                                (click)="OpenContactForm()"
                                            >
                                                Contact
                                            </button>
                                            <button
                                                class="select-btn w-full pricing-card-select-btn"
                                                *ngIf="
                                                    plan?.selected === false &&
                                                    plan?.CTA !== 'contact'
                                                "
                                                (click)="selectPlan(plan)"
                                            >
                                                <i class="pi pi-plus"> </i>
                                                Subscribe
                                            </button>
                                       </div>

                                    </div>
                                    <div class="col-12">
                                        <small class="text-info" *ngIf="plan.freeSubscription">$0.99/txn</small>
                                        <small class="text-info" *ngIf="!plan.freeSubscription">&nbsp;</small>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>
                    <div
                        class="hardware-container pt-1 package-separator py-3"
                        *ngIf="_signup.selectedPlans?.length > 0"
                    >
                        <div
                            class="register-items"
                            *ngIf="_signup.selectedPlans[0].addons?.length > 0"
                        >
                            <h2>Add-ons</h2>
                            <div class="flex flex-wrap">
                                <div
                                    class="col-12 md:col-3 lg:col-4 xl:col-4  text-align-center "
                                    *ngFor="
                                    let plan of _signup.selectedPlans[0]
                                        .addons
                                "
                                >
                                <div [class]="
                                            (plan.selected && !plan?.defaultAddedInSubscription) ? 'planselected' : ''
                                        "></div>
                                    <p-card class=" widget" *ngIf="!plan?.defaultAddedInSubscription" [ngClass]="{'selected-subscription': plan.selected}">

                                        <h4 class="package-title">{{ plan.planName }}</h4>
                                        <div class="price">
                                            <span class="amount">
                                                <span class="font-bold"> {{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? (plan?.yearlyPrice | currency | currencySpacing)
                                                        : (plan?.monthlyPrice
                                                        | currency | currencySpacing)
                                                }}</span>
                                               </span>
                                            <span class="duration">/mo.</span>
                                            <button
                                                class="selected-btn w-full pricing-card-selected-btn"
                                                *ngIf="
                                                    (plan?.selected === true &&
                                                    plan?.CTA !== 'contact') ||
                                                    (plan?.defaultAddedInSubscription == true)
                                                "
                                                (click)="selectAddon(plan)"
                                                [disabled]="
                                                    plan?.defaultAddedInSubscription == true
                                                "
                                            >
                                                <i *ngIf="!plan?.defaultAddedInSubscription" class="pi pi-minus"></i>
                                                <span *ngIf="plan?.defaultAddedInSubscription" title="Included in subscription">
                                                    <small>&nbsp; âœ“  Included in subscription</small>
                                                </span>
                                                <span *ngIf="!plan?.defaultAddedInSubscription">&nbsp; Unsubscribe</span>
                                            </button>

                                            <button
                                                class="select-btn w-full pricing-card-select-btn"
                                                *ngIf="plan?.CTA === 'contact'"
                                                (click)="OpenContactForm()"
                                            >
                                                Contact
                                            </button>
                                            <button
                                                class="select-btn w-full pricing-card-select-btn"
                                                *ngIf="
                                                    plan?.selected === false &&
                                                    plan?.CTA !== 'contact' &&
                                                    plan?.defaultAddedInSubscription == false
                                                "
                                                (click)="selectAddon(plan)"
                                            >
                                                <i class="pi pi-plus"></i>&nbsp;
                                                Add
                                            </button>
                                        </div>
                                    </p-card>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="hardware-container pt-1 package-separator py-3"
                        *ngIf="(isShowRegistersAndLocations || showHardwares)"
                    >
                        <!-- <h2>Manage registers/locations & hardware for your Store POS</h2> -->
                        <div class="hardware-box" *ngIf="(isShowRegistersAndLocations)">
                            <div class="register-location" *ngIf="_signup.selectedPlans[0]?.id >2">
                                <h3>Registers/Locations</h3>
                                <!-- <p>
                                    One register and one location are free. Additional costs apply for each extra register or location.
                                </p> -->
                                <div class="register-items">
                                    <div
                                        class="register-item"
                                        *ngFor="
                                            let item of registersAndLocationsList ; let i = index
                                        "
                                    >
                                        <label>{{ item.name }}</label>
                                        <span>
                                            <span class="font-bold">{{item.price | currency | currencySpacing}}</span>/mo.</span>

                                        <div class="quantity">
                                            <button
                                                (click)="
                                                    subRegistersAndLocations(
                                                        item
                                                    )
                                                "
                                                [disabled]="item.quantity == (i == 0 ? item.defaultRegister : item.defaultLocation)"
                                            >
                                                -
                                            </button>
                                            <input
                                                type="number"
                                                [disabled]="true"
                                                [(ngModel)]="item.quantity"
                                                min="(i == 0 ? item.defaultRegister : item.defaultLocation )"
                                                max="99"
                                            />
                                            <button
                                                (click)="
                                                    addRegistersAndLocations(
                                                        item
                                                    )
                                                "

                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="hardware"
                                *ngIf="showHardwares   && hardwaresList.length >0"
                            >
                                <div
                                    class="flex justify-content-between custom-hardware"
                                >
                                    <h3>Add Hardware</h3>
                                    <div class="custom-checkbox">
                                        <label>
                                            I do not need any hardware.
                                            <p-checkbox
                                                binary="true"
                                                [(ngModel)]="isShowHardware"
                                                [ngModelOptions]="{
                                                    standalone: true
                                                }"
                                                (onChange)="onSelect($event)"
                                                inputId="binary"
                                            ></p-checkbox>
                                        </label>
                                    </div>
                                </div>

                                <div
                                    class="hardware-items"
                                    *ngIf="!isShowHardware && hardwaresList.length >0"
                                >
                                    <div
                                        class="hardware-card"
                                        *ngFor="let hardware of hardwaresList"
                                        title="{{hardware?.title}}"
                                    >
                                        <img
                                            [src]="hardware?.image"
                                            alt="{{hardware?.title}}"
                                            title="{{hardware?.title}}"
                                        />
                                        <h4 *ngIf="hardware?.title.length >0">{{ hardware?.title }}</h4>
                                        <h4 *ngIf="hardware?.title.length ==0"></h4>
                                        <p>
                                            <!-- <span class="title" *ngIf="hardware?.isLease">
                                               <div class="flex flex-column px-3 py-2">
                                                    <div class="flex justify-content-start py-1">
                                                        <p-radioButton
                                                            name="pricingOption"
                                                            value="OneTimePrice"
                                                            (ngModelChange)="onPricingOptionChange($event, hardware)"
                                                            [(ngModel)]="hardware.selectedPricingOption"
                                                            inputId="OneTimePrice{{ hardware?.title }}"
                                                        ></p-radioButton>
                                                        <label
                                                            for="OneTimePrice{{ hardware?.title }}"
                                                            class="ml-2 mr-1"
                                                        >
                                                            <span class="font-bold">{{ hardware?.price | currency | currencySpacing }}</span>
                                                            <small class="hardware-price-info"> (One-time purchase)</small>
                                                        </label>
                                                    </div>
                                                    <div class="flex  justify-content-start py-1">
                                                        <p-radioButton
                                                            name="pricingOption"
                                                            value="LeasePrice"
                                                            [(ngModel)]="hardware.selectedPricingOption"
                                                            (ngModelChange)="onPricingOptionChange($event, hardware)"
                                                            inputId="leasePrice{{ hardware?.title }}"
                                                        ></p-radioButton>
                                                        <label
                                                            for="leasePrice{{ hardware?.title }}"
                                                            class="ml-2 mr-1"
                                                        >
                                                            <span class="font-bold">{{ hardware?.leasePrice | currency | currencySpacing }}</span>/mo.
                                                            <small class="hardware-price-info">(Up to 48-mo. lease)</small>
                                                        </label>
                                                    </div>
                                               </div>
                                            </span> -->
                                            <span >
                                                <div class="flex flex-column px-3 py-2">
                                                    <div class="flex py-1 justify-content-center">
                                                        <label
                                                            class="ml-2 mr-3 "
                                                        >
                                                        <span class="font-bold">{{ hardware?.price | currency | currencySpacing }}</span>
                                                        <!-- <small class="hardware-price-info"> (One-time purchase only) </small> -->
                                                        </label>
                                                    </div>
                                                </div>

                                                <div style="height: 28px;"></div>
                                            </span>
                                        </p>
                                        <div
                                            class="flex justify-content-between"
                                        >
                                            <span
                                                title="{{hardware?.title}}"
                                                class="view-btn cursor-pointer"
                                                (click)="
                                                    showHardwareDetail(hardware)
                                                "
                                            >
                                            ℹ️  Details
                                            </span>
                                            <div class="quantity">
                                                <button
                                                    (click)="
                                                        subHardware(hardware)
                                                    "
                                                    [disabled]="
                                                        hardware.selectedQuantity ===
                                                        0
                                                    "
                                                >
                                                    -
                                                </button>
                                                <input
                                                    type="number"
                                                    [(ngModel)]="
                                                        hardware.selectedQuantity
                                                    "
                                                    (onChange)="
                                                        hardwareQuantity()
                                                    "
                                                    [disabled]="true"
                                                    min="0"
                                                    max="99"
                                                />
                                                <button
                                                    (click)="
                                                        addHardware(hardware)
                                                    "
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="hardware-container">
                        <h2 class="pb-4 m-0 px-0">Business Address</h2>
                        <form [formGroup]="addressForm" class="form-container">
                            <div class="hardware-box">
                                <div class="col px-0 mx-0">
                                    <label class="control-label font-medium">
                                        Street address
                                        <span
                                            style="
                                                color: red;
                                                font-size: 1.25rem;
                                            "
                                            >*</span
                                        >
                                    </label>
                                    <input
                                        style="width: 100%"
                                        type="text"
                                        pInputText
                                        placeholder="House number and street name"
                                        name="Address"
                                        [ngClass]="{
                                            'ng-dirty ng-invalid':
                                                bf.address.invalid &&
                                                bf.address.touched
                                        }"
                                        [formControl]="
                                            $any(addressForm.controls)[
                                                'address'
                                            ]
                                        "
                                        class="mt-2"
                                    />
                                    <div *ngIf="bf.address?.touched">
                                        <div
                                            *ngIf="bf.address.errors?.required"
                                            class="invalid-feedback"
                                            style="margin-top: 7px"
                                        >
                                            This field is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col px-0 mx-0">
                                    <label class="control-label font-medium">

                                    </label>
                                    <input
                                        style="width: 100%"
                                        type="text"
                                        pInputText
                                         placeholder="Apartment, suite, unit, building, floor, etc."
                                        name="Address 2"
                                        [formControl]="
                                            $any(addressForm.controls)[
                                                'address2'
                                            ]
                                        "
                                        class="mt-2"
                                    />
                                </div>
                                <div class="grid ml-2" style="margin-top: 10px">
                                    <div
                                        class="col-12 md:col-12 lg:col-4 xl:col-4 ml-0 pl-0"
                                    >
                                        <label class="control-label"
                                            ><strong
                                                >Zip Code
                                                <span
                                                    style="
                                                        color: red;
                                                        font-size: 1.25rem;
                                                    "
                                                    >*</span
                                                >
                                            </strong></label
                                        >
                                        <br />
                                        <input
                                            style="width: 100%"
                                            type="text"
                                            pInputText
                                            placeholder="Zip Code"
                                            name="Zip Code"
                                            [ngClass]="{
                                                'ng-dirty ng-invalid':
                                                    bf.zipCode.invalid &&
                                                    bf.zipCode.touched
                                            }"
                                            [formControl]="
                                                $any(addressForm.controls)[
                                                    'zipCode'
                                                ]
                                            "
                                            class="mt-2"
                                            (input)="
                                                zipcodeInputEvent(
                                                    $event.target.value
                                                )
                                            "
                                            maxlength="10"
                                        />
                                        <div *ngIf="bf.zipCode?.touched">
                                            <div
                                                *ngIf="
                                                    bf.zipCode.errors?.required
                                                "
                                                class="invalid-feedback"
                                                style="margin-top: 7px"
                                            >
                                                This field is required.
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="col-12 md:col-12 lg:col-4 xl:col-4 ml-0 pl-0"
                                    >
                                        <label class="control-label"
                                            ><strong
                                                >City
                                                <span
                                                    style="
                                                        color: red;
                                                        font-size: 1.25rem;
                                                    "
                                                    >*</span
                                                >
                                            </strong></label
                                        >
                                        <br />
                                        <span
                                            class="p-input-icon-right"
                                            [style]="{ width: '100%' }"
                                        >
                                            <i
                                                class="pi pi-spin pi-spinner"
                                                *ngIf="showCityWait"
                                            ></i>
                                            <input
                                                style="width: 100%"
                                                type="text"
                                                pInputText
                                                placeholder="City"
                                                name="City"
                                                [ngClass]="{
                                                    'ng-dirty ng-invalid':
                                                        bf.city.invalid &&
                                                        bf.city.touched
                                                }"
                                                formControlName="city"
                                                class="mt-2"
                                            />
                                            <div *ngIf="bf.city?.touched">
                                                <div
                                                    *ngIf="
                                                        bf.city.errors?.required
                                                    "
                                                    class="invalid-feedback"
                                                    style="margin-top: 7px"
                                                >
                                                    This field is required.
                                                </div>
                                            </div>
                                            <div
                                                *ngIf="
                                                    bf.city?.touched &&
                                                    bf.city.errors?.invalid
                                                "
                                                class="invalid-feedback"
                                                style="margin-top: 7px"
                                            >
                                                Invalid city.
                                            </div>
                                        </span>
                                    </div>

                                    <div
                                        class="col-12 md:col-12 lg:col-4 xl:col-4 ml-0 pl-0"
                                    >
                                        <label class="control-label"
                                            ><strong
                                                >State
                                                <span
                                                    style="
                                                        color: red;
                                                        font-size: 1.25rem;
                                                    "
                                                    >*</span
                                                >
                                            </strong></label
                                        >
                                        <br />
                                        <p-dropdown
                                            [style]="{
                                                width: '100%',
                                                'margin-top': '7px'
                                            }"
                                            class="p-dropdown-1"
                                            appendTo="body"
                                            [options]="usaStates"
                                            optionLabel="name"
                                            [filter]="true"
                                            filterBy="name"
                                            (onChange)="onStateChange($event)"
                                            [(ngModel)]="selectedState"
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                        ></p-dropdown>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div
                        class="hardware-container"
                        *ngIf="isShowRegistersAndLocations"
                    >
                        <div class="flex justify-content-between py-2 pr-4">
                            <h2>Shipping Address</h2>
                            <span
                                >Use Business Address For Shipment
                                <span class="pl-2">
                                    <p-checkbox
                                        binary="true"
                                        [(ngModel)]="
                                            isBusinessAddressisShippingAddress
                                        "
                                        [ngModelOptions]="{ standalone: true }"
                                        (onChange)="
                                            onShowShippingAddress($event)
                                        "
                                        inputId="binary"
                                    ></p-checkbox>
                                </span>
                            </span>
                        </div>
                        <ng-container
                            *ngIf="!isBusinessAddressisShippingAddress"
                        >
                            <form [formGroup]="shippingForm" class="form-container">
                                <div class="hardware-box">
                                    <div class="col px-0 mx-0">
                                        <label
                                            class="control-label font-medium"
                                        >
                                            Street address
                                            <span
                                                style="
                                                    color: red;
                                                    font-size: 1.25rem;
                                                "
                                                >*</span
                                            >
                                        </label>
                                        <input
                                            style="width: 100%"
                                            type="text"
                                            pInputText
                                            placeholder="House number and street name"
                                            name="Address"
                                            [ngClass]="{
                                                'ng-dirty ng-invalid':
                                                    sf.address.invalid &&
                                                    sf.address.touched
                                            }"
                                            [formControl]="
                                                $any(shippingForm.controls)[
                                                    'address'
                                                ]
                                            "
                                            class="mt-2"
                                        />
                                        <div *ngIf="sf.address?.touched">
                                            <div
                                                *ngIf="
                                                    sf.address.errors?.required
                                                "
                                                class="invalid-feedback"
                                                style="margin-top: 7px"
                                            >
                                                This field is required.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col px-0 mx-0">
                                        <label
                                            class="control-label font-medium"
                                        >
                                        </label>
                                        <app-text-input
                                            [formControl]="
                                                $any(shippingForm.controls)[
                                                    'address2'
                                                ]
                                            "
                                            [name]="'Address 2'"
                                            [label]="''"
                                            placeholder="Apartment, suite, unit, building, floor, etc."
                                        ></app-text-input>
                                    </div>
                                    <div
                                        class="grid ml-2"
                                        style="margin-top: 10px"
                                    >
                                        <div
                                            class="col-12 md:col-12 lg:col-4 xl:col-4 ml-0 pl-0"
                                        >
                                            <label class="control-label"
                                                ><strong
                                                    >Zip Code
                                                    <span
                                                        style="
                                                            color: red;
                                                            font-size: 1.25rem;
                                                        "
                                                        >*</span
                                                    >
                                                </strong></label
                                            >
                                            <br />
                                            <input
                                                style="width: 100%"
                                                type="text"
                                                pInputText
                                                placeholder="Zip Code"
                                                name="Zip Code"
                                                [ngClass]="{
                                                    'ng-dirty ng-invalid':
                                                        sf.zipCode.invalid &&
                                                        sf.zipCode.touched
                                                }"
                                                [formControl]="
                                                    $any(shippingForm.controls)[
                                                        'zipCode'
                                                    ]
                                                "
                                                class="mt-2"
                                                (input)="
                                                    zipcodeInputSEvent(
                                                        $event.target.value
                                                    )
                                                "
                                            />
                                            <div *ngIf="sf.zipCode?.touched">
                                                <div
                                                    *ngIf="
                                                        sf.zipCode.errors
                                                            ?.required
                                                    "
                                                    class="invalid-feedback"
                                                    style="margin-top: 7px"
                                                >
                                                    This field is required.
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class="col-12 md:col-12 lg:col-4 xl:col-4 ml-0 pl-0"
                                        >
                                            <label class="control-label"
                                                ><strong
                                                    >City
                                                    <span
                                                        style="
                                                            color: red;
                                                            font-size: 1.25rem;
                                                        "
                                                        >*</span
                                                    >
                                                </strong></label
                                            >
                                            <br />
                                            <span
                                                class="p-input-icon-right"
                                                [style]="{ width: '100%' }"
                                            >
                                                <i
                                                    class="pi pi-spin pi-spinner"
                                                    *ngIf="showSCityWait"
                                                ></i>
                                                <input
                                                    style="width: 100%"
                                                    type="text"
                                                    pInputText
                                                    placeholder="City"
                                                    name="City"
                                                    [ngClass]="{
                                                        'ng-dirty ng-invalid':
                                                            sf.city.invalid &&
                                                            sf.city.touched
                                                    }"
                                                    formControlName="city"
                                                    class="mt-2"
                                                />
                                                <div *ngIf="sf.city?.touched">
                                                    <div
                                                        *ngIf="
                                                            sf.city.errors
                                                                ?.required
                                                        "
                                                        class="invalid-feedback"
                                                        style="margin-top: 7px"
                                                    >
                                                        This field is required.
                                                    </div>
                                                </div>
                                            </span>
                                        </div>

                                        <div
                                            class="col-12 md:col-12 lg:col-4 xl:col-4 ml-0 pl-0"
                                        >
                                            <label class="control-label"
                                                ><strong
                                                    >State
                                                    <span
                                                        style="
                                                            color: red;
                                                            font-size: 1.25rem;
                                                        "
                                                        >*</span
                                                    >
                                                </strong></label
                                            >
                                            <br />
                                            <p-dropdown
                                                [style]="{
                                                    width: '100%',
                                                    'margin-top': '7px'
                                                }"
                                                class="p-dropdown-1"
                                                appendTo="body"
                                                [options]="usaStates"
                                                optionLabel="name"
                                                [filter]="true"
                                                filterBy="name"
                                                [(ngModel)]="selectedSState"
                                                [ngModelOptions]="{
                                                    standalone: true
                                                }"
                                            ></p-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ng-container>
                    </div>
                </div>


                <div class="xl:col-4 lg:col-6 md:col-12 sm:col-12">
                    <div class="checkout-summary">
                        <div class="interval-section1 top-section border-bottom-none p-3"  >
                            <span class="heading flex mb-2"
                                >Billing Interval</span
                            >
                            <div class="summary-section">
                                <div class="col">
                                    <span class="title">
                                        <p-radioButton
                                            name="interval"
                                            value="Monthly"
                                            (click)="selectOption('Monthly')"
                                            [(ngModel)]="
                                                _signup.selectedPlanInterval
                                            "
                                            inputId="ingredient1"
                                        ></p-radioButton>
                                        <label
                                            for="ingredient1"
                                            class="ml-2 mr-3"
                                        >
                                        Monthly Subscription
                                        </label></span
                                    >
                                    <span class="title"
                                        ><p-radioButton
                                            name="interval"
                                            value="Yearly"
                                            (click)="selectOption('Yearly')"
                                            [(ngModel)]="
                                                _signup.selectedPlanInterval
                                            "
                                            inputId="ingredient2"
                                        ></p-radioButton>
                                        <label
                                            for="ingredient2"
                                            class="ml-2 mr-3"
                                        >
                                        Annual  Subscription
                                        </label></span
                                    >
                                </div>
                            </div>
                        </div>

                        <div class="top-section p-3">
                            <span class="heading font-semibold flex mb-2">Your Subscriptions</span>
                            <div class="summary-section flex flex-column align-content-center pb-4">

                                <ng-container
                                    *ngFor="let plan of _signup.selectedPlans"
                                >
                                    <div class="summary-item1 py-2 flex justify-content-between align-content-center">
                                        <div class="   plan-title fs-4  text-start">{{
                                            plan?.planName
                                        }}</div>
                                        <!-- <div
                                            class="info col-3  justify-content-center text-center"
                                            >
                                            <span >
                                                Billed  <span *ngIf="!isFreeSubscription" >
                                                    {{
                                                        _signup.selectedPlanInterval ===
                                                        "Yearly"
                                                            ? "annually"
                                                            : "monthly"
                                                    }}
                                                </span>
                                            </span>
                                        </div> -->
                                        <div
                                            class=" flex  text-end"
                                            >
                                            <div *ngIf="!isFreeSubscription">
                                                {{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? 12
                                                        : 1
                                                }}
                                                Ã—
                                            </div>
                                            <div>
                                                &nbsp;
                                                {{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? (plan?.yearlyPrice
                                                          | currency | currencySpacing)
                                                        : (plan?.monthlyPrice
                                                          | currency | currencySpacing)
                                                }}
                                            </div>
                                            <div *ngIf="!isFreeSubscription" class="font-medium">
                                                &nbsp; =
                                                {{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? ((12 * plan?.yearlyPrice)| currency | currencySpacing)
                                                        : ((1 * plan?.monthlyPrice)| currency | currencySpacing)
                                                }}

                                            </div>

                                        </div>
                                    </div>

                                    <div
                                        class="summary-item1 py-2 flex justify-content-between align-content-center"
                                        *ngFor="let addon of getselectedAddons"
                                    >
                                            <div class="  fs-4 plan-title  text-start">
                                                {{addon?.planName}}
                                                <small class="text-info d-block" *ngIf="addon?.defaultAddedInSubscription">(Included in subscription)</small>
                                            </div>
                                            <!-- <div
                                                class="info col-3 text-center"
                                                >Billed
                                                {{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? "annually"
                                                        : "monthly"
                                                }}
                                            </div> -->
                                            <div
                                                class="flex  text-end"
                                                >
                                                <div *ngIf="!addon?.defaultAddedInSubscription">
                                                    {{
                                                        _signup.selectedPlanInterval ===
                                                        "Yearly"
                                                            ? 12
                                                            : 1
                                                    }}

                                                    Ã—
                                                </div>
                                                <div *ngIf="!addon?.defaultAddedInSubscription">
                                                    &nbsp;
                                                    {{
                                                        _signup.selectedPlanInterval ===
                                                        "Yearly"
                                                            ? (addon?.yearlyPrice
                                                            | currency | currencySpacing)
                                                            : (addon?.monthlyPrice
                                                            | currency | currencySpacing)
                                                    }}
                                                </div>
                                                <div class="font-medium">
                                                    <span *ngIf="!addon?.defaultAddedInSubscription">&nbsp;=</span>
                                                    {{
                                                        _signup.selectedPlanInterval ===
                                                        "Yearly"
                                                            ? ((12 * addon?.yearlyPrice)| currency | currencySpacing)
                                                            : ((1 * addon?.monthlyPrice)| currency | currencySpacing)
                                                    }}
                                                </div>

                                        </div>
                                    </div>
                                </ng-container>
                                <div
                                    class="summary-item"
                                    *ngIf="
                                        _signup.selectedPlans?.length < 1
                                    "
                                >
                                    <span class="title">{{
                                        "No plan Selected"
                                    }}</span>
                                </div>
                            </div>
                        </div>

                        <div
                            class="top-section p-3"
                            *ngIf="
                                isShowRegistersAndLocations &&
                                _signup.selectedLocationsAndRegistersList
                                    ?.length > 0
                                    && (((_signup.selectedPlans[0]?.id != 4) && (_signup.selectedLocationsAndRegistersList[0].quantity > 1 ||
                            _signup.selectedLocationsAndRegistersList[1].quantity > 1)) ||
                            ((_signup.selectedPlans[0]?.id == 4) && (_signup.selectedLocationsAndRegistersList[0].quantity > 4 ||
                            _signup.selectedLocationsAndRegistersList[1].quantity > 2)))
                                    "
                        >

                            <span class="heading font-semibold flex mb-2"
                            *ngIf="((_signup.selectedPlans[0]?.id != 4) && (_signup.selectedLocationsAndRegistersList[0].quantity > 1 ||
                            _signup.selectedLocationsAndRegistersList[1].quantity > 1)) ||
                            ((_signup.selectedPlans[0]?.id == 4) && (_signup.selectedLocationsAndRegistersList[0].quantity > 4 ||
                            _signup.selectedLocationsAndRegistersList[1].quantity > 2)) "
                            >Additional Register/location</span>
                            <div class="summary-section py-2 flex flex-column align-content-center pb-4">
                                <ng-container
                                    *ngFor="
                                        let item of _signup.selectedLocationsAndRegistersList; let i = index
                                    "
                                >
                                    <div class="summary-item1 py-2 flex justify-content-between align-content-center"
                                        *ngIf="item?.quantity > (i == 0 ? _signup.selectedPlans[0].defaultRegister : _signup.selectedPlans[0].defaultLocation)">
                                        <div class="  fs-4 plan-title  text-start">{{ item.name }}</div>
                                        <!-- <span
                                            class="info col-4 flex justify-content-center"
                                            >Billed
                                            {{
                                                _signup.selectedPlanInterval ===
                                                "Yearly"
                                                    ? "yearly"
                                                    : "monthly"
                                            }}</span
                                        > -->
                                        <div
                                            class="flex   text-end"
                                        >
                                            <div>
                                                {{
                                                    _signup.selectedPlanInterval ===
                                                    "Yearly"
                                                        ? 12
                                                        : 1
                                                }}
                                                Ã—
                                            </div>
                                            <div>
                                                &nbsp;
                                                <span >

                                                        ({{ item.quantity - (i == 0 ? _signup.selectedPlans[0].defaultRegister : _signup.selectedPlans[0].defaultLocation) }} x {{ item.price | currency | currencySpacing }})

                                                </span>
                                                <!-- <span *ngIf="_signup.selectedPlans[0]?.id == 4">

                                                    <span *ngIf="(item.name == 'Registers')">
                                                        ({{ item.quantity - 4 }} x {{ item.price | currency | currencySpacing }})

                                                    </span>
                                                    <span *ngIf="(item.name == 'Locations')">
                                                        ({{ item.quantity - 2 }} x {{ item.price | currency | currencySpacing }})
                                                    </span>
                                                </span> -->

                                            </div>
                                            <div class="font-medium ">&nbsp;=

                                                <span>
                                                    {{
                                                        _signup.selectedPlanInterval ===
                                                        "Yearly"
                                                            ? ((12 * ((item.quantity - (i == 0 ? _signup.selectedPlans[0].defaultRegister : _signup.selectedPlans[0].defaultLocation)) * item.price))| currency | currencySpacing)
                                                            : ((1 * ((item.quantity - (i == 0 ? _signup.selectedPlans[0].defaultRegister : _signup.selectedPlans[0].defaultLocation)) * item.price))| currency | currencySpacing)
                                                    }}
                                                </span>
                                                <!-- <span *ngIf="_signup.selectedPlans[0]?.id == 4">

                                                    <span *ngIf="(item.name == 'Registers')">

                                                        {{
                                                            _signup.selectedPlanInterval ===
                                                            "Yearly"
                                                                ? ((12 * ((item.quantity - 4) * item.price))| currency | currencySpacing)
                                                                : ((1 * ((item.quantity - 4) * item.price))| currency | currencySpacing)
                                                        }}
                                                    </span>
                                                    <span *ngIf="(item.name == 'Locations')">

                                                        {{
                                                            _signup.selectedPlanInterval ===
                                                            "Yearly"
                                                                ? ((12 * ((item.quantity - 2) * item.price))| currency | currencySpacing)
                                                                : ((1 * ((item.quantity - 2) * item.price))| currency | currencySpacing)
                                                        }}
                                                    </span>
                                                </span> -->
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div
                            class="top-section p-3"
                            *ngIf="
                                isShowRegistersAndLocations &&
                                !isShowHardware &&
                                this._signup.selectedHardware?.length > 0
                            "
                        >
                            <span class="heading font-semibold flex mb-2">Hardware</span>
                            <div class="summary-section flex flex-column align-content-center pb-4">
                                <div
                                    *ngFor="let select of this._signup.selectedHardware"
                                >
                                    <div class="summary-item1 py-2 flex justify-content-between align-content-center">
                                        <div class="  fs-4 plan-title   text-start">{{ select?.title }}
                                            <small class="text-info" *ngIf="select?.isLease && select.selectedPricingOption == 'LeasePrice'">(Up to 48-mo. lease)</small>
                                        </div>
                                        <!-- <div class="info col-4 flex justify-content-center">Pay one-time</div> -->
                                        <div class=" flex   text-end">
                                            {{ select?.selectedQuantity }} x &nbsp;
                                            <span *ngIf="select?.isLease">
                                                <span *ngIf="select.selectedPricingOption == 'OneTimePrice'">{{select?.price | currency | currencySpacing}}</span>
                                                <span *ngIf="select.selectedPricingOption == 'LeasePrice'">{{select?.leasePrice| currency | currencySpacing}}/mo.</span>
                                             </span>
                                             <span *ngIf="!select?.isLease">
                                                 {{ select?.price | currency | currencySpacing }}
                                             </span>&nbsp; = &nbsp;
                                            <div class="font-medium"> {{(select?.selectedQuantity *
                                                (select?.isLease ? (select?.selectedPricingOption == 'OneTimePrice' ? select?.price : select?.leasePrice ) : select?.price)
                                                ) | currency | currencySpacing}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="top-section p-3">
                            <div class="summary-totals">
                                <div
                                    class="total-item pt-3 pb-5 flex justify-content-between align-content-center"
                                >
                                    <span class="flex flex-column">
                                        <div class="plan-title flex mb-2 font-medium">Subtotal</div>
                                        <small class="small-text" *ngIf="!isFreeSubscription">
                                            {{
                                                _signup.selectedPlanInterval == "Yearly"
                                                    ? "Annually"
                                                    : "Monthly"
                                            }}
                                            subscription until
                                            {{
                                                getNextDate(
                                                    _signup.selectedPlanInterval
                                                ) | date : "dd MMM, yyyy"
                                            }}
                                        </small></span
                                    >
                                    <div class="font-medium plan-title">{{ subTotal | currency | currencySpacing }}</div >
                                </div>
                                <!-- <div
                                *ngIf="!isFreeSubscription"
                                    class="total-item flex plan-title justify-content-between"
                                >
                                    <span class="title">Discount</span>
                                    <span class="font-medium">
                                        <ng-container *ngIf="discount > 0"
                                            >-</ng-container
                                        >
                                        {{ discount | currency | currencySpacing }}</span
                                    >
                                </div> -->
                                <div
                                    class="total-item plan-title pt-3 pb-4 flex justify-content-between"
                                >
                                    <span class="title"
                                        >Sales Tax
                                        <small
                                            class="small-text"
                                            *ngIf="taxRate > 0"
                                        >
                                            ({{ taxRate }}%)</small
                                        >
                                    </span>
                                    <span class="font-medium">{{ taxAmount | currency | currencySpacing }}</span>
                                </div>
                            </div>

                            <!-- <div class="coupon-section px-0 flex-column">
                                <div class="flex inp-btn">
                                    <input
                                        type="text"
                                        class="coupon-input"
                                        placeholder="Have a coupon or promo code?"
                                        [(ngModel)]="discountValue"
                                        (change)="inputVlaue()"
                                    />
                                    <button
                                        class="apply-btn"
                                        (click)="apply()"
                                        [disabled]="
                                            discountValue === null ||
                                            discountValue === ''
                                        "
                                    >
                                        Apply
                                    </button>
                                </div>
                                <small class="invalid-code" *ngIf="inValidCode"
                                    >Coupon code is not valid.</small
                                >
                            </div>
                            <div
                                class="applied-coupon"
                                *ngIf="applyDiscount !== null"
                            >
                                <span>{{ applyDiscount }}</span>
                                <button
                                    class="remove-coupon"
                                    (click)="cancel()"
                                >
                                    âœ•
                                </button>
                            </div> -->
                        </div>

                        <div class="top-section p-3 flex justify-content-between  font-semibold due-amount">
                            <strong>Amount due</strong>
                            <span>{{ grandTotal | currency | currencySpacing }}</span>
                        </div>
                    </div>
                    <div class="flex items-center gap-1" *ngIf="_signup.accountVerified">
                        <p-checkbox [(ngModel)]="consentCheckBox" inputId="ny" [binary]="true"></p-checkbox>
                        <label for="ny" class="ml-2 text-lg">By clicking "Proceed for Payment", you agree to our <strong  (click)="showTerms()" class="cursor-pointer underline">terms</strong> and <strong (click)="showEndUserAggreement()" class="cursor-pointer underline">privacy policy</strong>.</label>

                    </div>

                    <div
                        class="button-container flex justify-content-center my-6"
                    >
                        <button
                            class="btn proceed w-full"
                            [disabled]="
                            (!consentCheckBox) ||
                                (grandTotal <= 0 && !isFreeSubscription) ||
                                _signup.selectedPlans == undefined ||
                                    _signup.selectedPlans?.length == 0 ||
                                bf.address.errors?.required ||
                                bf.city.errors?.invalid ||
                                    bf.city.errors?.required
                            "
                            (click)="saveFn()"
                        >
                        Proceed for Payment
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


